var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadDocs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14286 19.3574H11.2857M6.14286 14.2146H11.2857M6.14286 9.07171H7.42857M11.2857 1.35742H5.11429C3.67416 1.35742 2.95408 1.35742 2.40403 1.63769C1.92017 1.88422 1.5268 2.27759 1.28027 2.76145C1 3.3115 1 4.03158 1 5.47171V20.386C1 21.8261 1 22.5463 1.28027 23.0963C1.5268 23.5801 1.92017 23.9735 2.40403 24.22C2.95408 24.5003 3.67416 24.5003 5.11429 24.5003H11.2857M11.2857 1.35742L19 9.07171M11.2857 1.35742V7.01456C11.2857 7.73463 11.2857 8.09467 11.4259 8.36969C11.5492 8.61161 11.7457 8.8083 11.9877 8.93158C12.2627 9.07171 12.6227 9.07171 13.3429 9.07171H19M19 9.07171V12.286",
    stroke: "#5EB0CA",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDocs);
export default __webpack_public_path__ + "static/media/uploadDocs.58a63c4a12ae612ceecaa77392606435.svg";
export { ForwardRef as ReactComponent };